import React from 'react';
import { kenoBetStore } from '../../store/kenoBetStore';

function CloseNumpadButton({ validateNumpadValue }) {
  const { setIsOpenNumpad } = kenoBetStore;
  return (
    <div className='numpad-item numpad-down-btn-block'>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        className='numpad-down-btn'
        onClick={() => {
          setIsOpenNumpad(false);
          validateNumpadValue();
        }}
      >
        <i className=' icon-arrow-down' />
      </button>
    </div>
  );
}
export default CloseNumpadButton;
